import React, { useContext, useEffect, useState } from "react";
import FieldDate from "../../../../common/component/form/FieldDate";
import FieldText from "../../../../common/component/form/FieldText";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import { path } from "../../../../constants/apiPath";
import { StoreContext } from "../../../../store";
import { StoreContext as OldStoreContext } from "../../../../../Store/Provider";
import { useLocation, useNavigate } from "react-router-dom";
import instance from "../../../../common/api/interceptor";
import moment from "moment";
import useForm from "../../../../common/hooks/useForm";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { NotificationManager } from "react-notifications";
import ModalOrderSpecificsContainer from "../../../../constants/data/ModalOrderSpecificsContainer";
import { routeConstant } from "../../../../../Route/utils/routeConstant";
import Loading from "../../../loading/Loading";
import MainLayout from "../../../../common/layout/MainLayout";

function EditOrderSpecific() {
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const oldContext = useContext(OldStoreContext);
  const [edit, setEdit] = useState(false);
  const orderNumber = useForm();
  const cwOrderNumber = useForm();
  const adviceNumber = useForm();
  const invoiceNumber = useForm();
  const goodsDescription = useForm();
  const weight = useForm();
  const volume = useForm();
  const chargeableWeight = useForm();
  const additionalTerms = useForm();
  const confirmNumber = useForm();
  const orderDate = useForm();
  const recieverNameRequire = useForm();

  const [milestone, setMilestone] = useState([]);
  const reqWorkDate = useForm();
  const reqStoreDate = useForm();

  const currencycode = useForm();
  const container = useForm();
  const inco = useForm();
  const [splitNumber, setSplitNumber] = useState("0");
  const [supplierName, setSupplierName] = useState({ OrgCode: "" });
  const [supplierNameAdmin, setSupplierNameAdmin] = useState([]);
  const [reciverNameAdmin, setReciverNameAdmin] = useState([]);
  const [supplierAddress, setSupplierAddress] = useState({
    Address1: "",
    AddressPk: "",
  });
  const [recieverAddress, setRecieverAddress] = useState({
    Address1: "",
    AddressPk: "",
  });
  const [transportMode, setTransportMode] = useState({
    Description: "",
    Mode: "",
  });
  const [currency, setCurrency] = useState({ Code: "" });
  const [incoTerm, setIncoTerm] = useState({ Code: "" });
  const [orderStatus, setOrderStatus] = useState({ Description: "" });
  const [originCountry, setOriginCountry] = useState({ Description: "" });
  const [containerMode, setContainerMode] = useState({ Mode: "" });
  const [serviceLevel, setServiceLevel] = useState({ Description: "" });
  const [containerCountInfo, setContainerCountInfo] = useState([]);
  const [inputDisabled, setInputDisabled] = useState(false);
  const location = useLocation();
  const [senderAddOptions, setSenderAddOptions] = useState([]);
  const [reciverAddOptions, setReciverAddOptions] = useState([]);
  const [reciverName, setReciverName] = useState({ OrgCode: "" });
  const [sendingAgent, setSendingAgent] = useState({ OrgCode: "", OrgPk: "" });
  const [recivingAgent, setRecivingAgent] = useState({
    OrgCode: "",
    OrgPk: "",
  });
  const [sendingOptions, setSendingOptions] = useState([]);
  const [recivingOptions, setRecivingOptions] = useState([]);
  const [deleveryAddress, setDeleveryAddress] = useState({ Address1: "" });
  const [deleveryOptions, setDeleveryOptions] = useState([]);

  useEffect(() => {
    if (!location.state) {
      if (location.pathname.includes(routeConstant.ORDER_LIST)) {
        navigate(routeConstant.ORDER_LIST_PLACED, { replace: true });
      } else if (location.pathname.includes(routeConstant.ORDER_DASHBOARD)) {
        navigate(routeConstant.ORDER_DASHBOARD, { replace: true });
      }
    } else {
      console.log("location", location.state.editOrderJSON);
      setMilestone([
        ...(location.state.editOrderJSON.OrderMilstonesCollection ?? []),
      ]);

      const userdata = oldContext.omsUserData;

      if (userdata?.DefaultRole) {
        if (oldContext.omsUserData?.DefaultRole.includes("Admin")) {
          getSupplierBuyerListforAdmin("Buyer");
          getSupplierBuyerListforAdmin("Supplier");
        } else {
          getSupplierList();
        }
      }

      setInputDisabled(!context.userAccess?.EditOrderDetail);
      context.setUserData(userdata);

      if (oldContext.omsUserData?.DefaultRole.includes("Buyer")) {
        getAgentOrCarrier("ReceivingAgent", userdata.OrgPK);
        getAgentOrCarrier("SendingAgent", userdata.OrgPK);
      }

      const data = location.state.editOrderJSON.OrderHeader;
      console.log("setSupplierName", data);
      orderNumber.setValue(data.OrderNumber);
      adviceNumber.setValue(data.OrderPreAdviceId);
      invoiceNumber.setValue(data.OrderInvoiceNumber);
      setSplitNumber(data.SplitNumber !== "0" ? `/${data.SplitNumber}` : "");
      setSupplierName({
        OrgCode: data.OrderBuyerCode,
      });
      goodsDescription.setValue(data.OrderGoodsDescription);
      additionalTerms.setValue(data.OrderSpecialInstruction);
      confirmNumber.setValue(data.OrderConfirmNumber);

      setSendingAgent({
        OrgCode: data.OrderSendingAgentCode ?? "",
        OrgPk: data.OrderSendingAgentPK ?? "",
      });

      setRecivingAgent({
        OrgCode: data.OrderReceivingAgentCode ?? "",
        OrgPk: data.OrderReceivingAgentPK ?? "",
      });

      setDeleveryAddress({
        Address1: data?.OrderBuyerDeliveryAddress1 ?? "",
        AddressPk: data?.OrderBuyerDeliveryAddressPK ?? "",
      });

      setSupplierAddress({
        Address1: data.OrderSupplierAddress1,
        AddressPk: data.OrderSupplierAddressPK,
      });
      setRecieverAddress({
        Address1: data.OrderBuyerAddress1,
        AddressPk: data.OrderBuyerAddressPK,
      });
      weight.setValue(data.OrderActualWeight);
      volume.setValue(data.OrderActualVolume);
      chargeableWeight.setValue(data.OrderChargeableWeight);
      const arr = [];
      if (data.OrderContainerCollection) {
        data.OrderContainerCollection.map((ele, index) => {
          const obj = {
            ...ele,
            OrderContainerType: { Code: ele.OrderContainerType },
          };
          arr.push(obj);
        });
        setContainerCountInfo([...arr]);
      }
      reqWorkDate.setValue(data.OrderExWorksRequiredBy ?? "");
      reqStoreDate.setValue(data.OrderDeliveryRequiredBy ?? "");
      orderDate.setValue(data.OrderDate ?? "");
      setServiceLevel({
        Description: data.OrderServiceLevelcode,
        Code: data.OrderServiceLevelcode,
      });
      setTransportMode({
        Description: data.OrderTransportMode,
        Mode: data.OrderTransportMode,
      });
      setCurrency({ Code: data.OrderCurrencyCode });
      setContainerMode({ Mode: data.OrderContainerMode });
      setSupplierName({
        OrgPk: data.OrderSupplierPK ?? "",
        OrgCode: data.OrderSupplierCode ?? "",
        AddressPk: data.OrderSupplierAddressPK ?? "",
        Address1: data.OrderSupplierAddress1 ?? "",
        OrgName: data.OrderSupplierName ?? "",
      });
      setReciverName({
        OrgPk: data.OrderBuyerPK ?? "",
        OrgCode: data.OrderBuyerCode ?? "",
      });
      setOriginCountry({
        Description: data.OrderCountryOfOrigin,
        Code: data.OrderCountryOfOrigin,
      });
      setIncoTerm({ Code: data.OrderIncoTerm });
      setOrderStatus({ Description: data.OrderStatus, Code: data.OrderStatus });
      setEdit(location?.state?.edit ?? false);
    }
  }, [location.state]);

  useEffect(() => {
    if (
      oldContext.omsUserData?.DefaultRole.includes("Supplier") &&
      reciverName.OrgName
    ) {
      getAgentOrCarrier("ReceivingAgent", reciverName.OrgPk);
      getAgentOrCarrier("SendingAgent", reciverName.OrgPk);
    }
  }, [reciverName.OrgName]);

  const getSupplierList = () => {
    instance
      .get(path.GET_BUYER_SUPPIER)
      .then((res) => {
        context.setSupplierName(res.data ?? []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getSupplierBuyerListforAdmin = (role = "") => {
    instance
      .get(`${path.GET_BUYER_SUPPIER}?code=${role}`)
      .then((res) => {
        if (role === "Supplier") {
          setSupplierNameAdmin(res.data);
        } else if (role === "Buyer") {
          setReciverNameAdmin(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (supplierName.OrgCode) {
      getOrgAddress("sender", supplierName.OrgCode);
    }
  }, [supplierName]);

  useEffect(() => {
    if (reciverName.OrgCode) {
      getOrgAddress("reciver", reciverName.OrgCode);
    }
  }, [reciverName]);

  const getAgentOrCarrier = (type, orgPk) => {
    const url = `${path.AGENT_CARRIER}${type}&orgPk=${orgPk}`;

    instance
      .get(url)
      .then((res) => {
        console.log(type, res.data);
        // return res.data ?? [];
        if (type === "ReceivingAgent") {
          // if (res.data.length === 1) {
          //   setRecivingAgent(res.data[0])
          // }
          setRecivingOptions(res.data ?? []);
        } else if (type === "SendingAgent") {
          // if (res.data.length === 1) {
          //   setSendingAgent(res.data[0])
          // }
          setSendingOptions(res.data ?? []);
        }
      })
      .catch(() => {
        return [];
      });
  };

  const onNextHandler = (path) => {
    let flag = false;

    if (
      reciverName.OrgCode === "" &&
      oldContext.omsUserData?.DefaultRole.includes("Supplier")
    ) {
      recieverNameRequire.setError(true);
      recieverNameRequire.setErrorMsg("Buyer Name required");
      flag = true;
    }
    if (orderDate.value === "") {
      orderDate.setError(true);
      orderDate.setErrorMsg("Order Date required");
      flag = true;
    }

    if (containerMode.Mode === "") {
      container.setError(true);
      container.setErrorMsg("Container type required");
      flag = true;
    }

    if (incoTerm.Code === "") {
      inco.setError(true);
      inco.setErrorMsg("Inco term required");
      flag = true;
    }

    if (currency.Code === "") {
      currencycode.setError(true);
      currencycode.setErrorMsg("Currency code required");
      flag = true;
    }
    if (!flag) {
      const containerInfo = [];
      containerCountInfo.map((item) => {
        const con = {
          OrderContainerCountTypePk: item.OrderContainerCountTypePk,
          OrderContainerCountTypeOrderFK: item.OrderContainerCountTypeOrderFK,
          OrderContainerCount: item.OrderContainerCount,
          OrderContainerType: item.OrderContainerType.Code ?? "",
        };

        containerInfo.push(con);
      });

      const body = {
        ...location.state.editOrderJSON,
        OrderHeader: {
          ...location.state.editOrderJSON.OrderHeader,
          OrderContainerMode: containerMode.Mode ?? "",
          OrderConfirmDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          // SplitNumber: "0",
          OrderConfirmNumber: confirmNumber.value ?? "",
          OrderCountryOfOrigin: originCountry.Code ?? "",
          OrderCurrencyCode: currency.Code,
          OrderDate: orderDate.value
            ? moment(orderDate.value).format("YYYY-MM-DD HH:mm:ss")
            : moment().format("YYYY-MM-DD HH:mm:ss"),
          OrderDeliveryRequiredBy: reqStoreDate.value
            ? moment(reqStoreDate.value).format("YYYY-MM-DD HH:mm:ss")
            : "",
          OrderExWorksRequiredBy: reqWorkDate.value
            ? moment(reqWorkDate.value ?? "").format("YYYY-MM-DD HH:mm:ss")
            : "",
          OrderIncoTerm: incoTerm.Code ?? "",
          OrderInvoiceNumber: invoiceNumber.value ?? "",
          OrderNumber: orderNumber.value ?? "",
          OrderServiceLevelcode: serviceLevel.Code ?? "",
          OrderStatus: orderStatus.Code ?? "",
          OrderTransportMode: transportMode?.Mode ?? "",
          OrderGoodsDescription: goodsDescription.value,
          OrderSpecialInstruction: additionalTerms.value,
          OrderPreAdviceId: adviceNumber.value,
          OrderSendingAgentPK: sendingAgent?.OrgPk ?? "",
          OrderSendingAgentCode: sendingAgent?.OrgCode ?? "",
          OrderReceivingAgentCode: recivingAgent?.OrgCode ?? "",
          OrderReceivingAgentPK: recivingAgent?.OrgPk ?? "",
          OrderBuyerDeliveryAddressPK: deleveryAddress.AddressPk,
          OrderBuyerDeliveryAddress1: deleveryAddress?.Address1 ?? "",

          //buyer
          //buyer
          OrderBuyerCode: reciverName.OrgCode ?? "",
          // oldContext.omsUserData?.DefaultRole.includes("Buyer")
          //   ? context.userData.OrgCodes
          // : reciverName.OrgCode ?? "",
          OrderBuyerPK: reciverName.OrgPk ?? "",
          //  oldContext.omsUserData?.DefaultRole.includes("Buyer")
          //   ? reciverName.OrgPk
          //   : reciverName.OrgPk ?? "",
          OrderBuyerAddressPK: recieverAddress?.AddressPk ?? "",
          OrderBuyerAddress1: recieverAddress.Address1 ?? "",
          //supllier
          OrderSupplierPK: supplierName.OrgPk ?? "",
          // oldContext.omsUserData?.DefaultRole.includes(
          //   "Supplier"
          // )
          //   ? ""
          //   : supplierName.OrgPk ?? "",
          OrderSupplierCode: supplierName.OrgCode ?? "",
          // oldContext.omsUserData?.DefaultRole.includes(
          //   "Supplier"
          // )
          //   ? context.userData.OrgCodes
          //   : supplierName.OrgCode ?? "",
          OrderSupplierAddressPK: supplierAddress.AddressPk ?? "",
          OrderSupplierAddress1: supplierAddress.Address1 ?? "",
          OrderChargeableWeight: transportMode?.Mode?.includes("AIR")
            ? chargeableWeight.value
            : "",
          OrderActualVolume: transportMode?.Mode?.includes("SEA")
            ? volume.value
            : "",
          OrderActualWeight: transportMode?.Mode?.includes("SEA")
            ? weight.value
            : "",
          OrderContainerCollection: [...containerInfo],
          PlanningCollection: [],
        },
        OrderMilstonesCollection: [...milestone],
        OrderNotesCollection: [],
      };
      context.setEditOrderJSON({ ...body });
      console.log("order json", body);
      navigate(path, {
        state: { edit: edit, editOrderJSON: body },
      });
    } else {
      NotificationManager.error("Mandatory fields required", "", 3000);
    }
    // onPostOrder(path, body);
  };

  const getOrgAddress = (option, orgCode = "") => {
    if (option === "sender") {
      if (orgCode) {
        instance
          .get(`${path.GET_ORG_CONTACTS}?orgcode=${orgCode}`)
          .then((res) => {
            if (res.Is_Success) {
              setSenderAddOptions(res.data[0].Addresses ?? []);
            } else {
              NotificationManager.error(res.Message, "", 3000);
            }
          })
          .catch((err) => {
            console.error(err);
            if (err.response) {
              NotificationManager.error(err.response.data.Message, "", 3000);
            } else if (err.request) {
            } else if (err.message) {
            } else {
              NotificationManager.error("Something went wrong!", "", 3000);
            }
          });
      }
    } else {
      if (orgCode) {
        instance
          .get(`${path.GET_ORG_CONTACTS}?orgcode=${orgCode}`)
          .then((res) => {
            if (res.Is_Success) {
              setReciverAddOptions(res.data[0].Addresses ?? []);
              setDeleveryOptions(res.data[0].DeliveryAddresses ?? []);
            } else {
              NotificationManager.error(res.Message, "", 3000);
            }
          })
          .catch((err) => {
            console.error(err);
            if (err.response) {
              NotificationManager.error(err.response.data.Message, "", 3000);
            } else if (err.request) {
            } else if (err.message) {
            } else {
              NotificationManager.error("Something went wrong!", "", 3000);
            }
          });
      }
    }
  };

  useEffect(() => {
    if (context.userData?.OrgCodes) {
      if (oldContext.omsUserData?.DefaultRole.includes("Supplier")) {
        getOrgAddress("sender", supplierName.OrgCode);
      } else {
        getOrgAddress("reciver", reciverName.OrgCode);
      }
    }
  }, [context.userData]);

  const onAddContainerCountInfo = () => {
    const containerCountArray = [...containerCountInfo];
    containerCountArray.push({
      ...ModalOrderSpecificsContainer,
    });
    setContainerCountInfo([...containerCountArray]);
  };

  const onRemoveContainerCountInfo = (itemIndex, container) => {
    const containerCountArray = [...containerCountInfo];

    if (container.OrderContainerCountTypePk) {
      const url = `${path.DELETE_ORDER_SPECIFIC_CONTAINERS}?orderPK=${location.state.editOrderJSON.OrderHeader.OrderPK}&OrdercontainerPK=${container.OrderContainerCountTypePk}`;
      instance
        .delete(url)
        .then((res) => {
          if (res.Is_Success) {
            containerCountArray.splice(itemIndex, 1);
            setContainerCountInfo([...containerCountArray]);
            context.setEditOrderJSON({
              ...location.state.editOrderJSON,
              OrderHeader: {
                ...location.state.editOrderJSON.OrderHeader,
                OrderContainerCollection: [...containerCountArray],
              },
            });

            NotificationManager.success(res.Message, "", 3000);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      const containerCountArray = [...containerCountInfo];
      containerCountArray.splice(itemIndex, 1);
      setContainerCountInfo([...containerCountArray]);
    }
  };

  const onContainerHandler = (lable, value, arrIndex) => {
    let arr = [...containerCountInfo];
    arr.map((item, i, arr) => {
      if (lable == "OrderContainerCount") {
        arr[arrIndex][lable] = parseInt(value).toFixed(0);
      } else {
        arr[arrIndex][lable] = value;
      }
    });
    setContainerCountInfo([...arr]);
  };

  const onLineValueChange = (lable, value, index) => {
    const arr = [...milestone];
    arr[index][lable] = value;
    setMilestone([...milestone]);
    // setOrderLineJson([...arr]);
  };

  if (!location.state) return <Loading />;

  return (
    <MainLayout>
      <LayoutCreateOrder
        onNextHandler={onNextHandler}
        title="Edit Order"
        editComp={true}
      >
        <div className="_form-div">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-7 col-12  _newOrderCol12">
                <div className="row">
                  <div className="col-md-6 col-12 _newOrderCol1">
                    <h5>ORDER NUMBER</h5>
                    <div className="_newOrderCol1Content">
                      <FieldText
                        disabled={inputDisabled}
                        label={
                          <div className="_mandatoryfieldName">
                            Order number
                            <span className="_madatoryFieldSymbol">*</span>
                          </div>
                        }
                        value={orderNumber.value + splitNumber}
                        onChange={orderNumber.onChange}
                        error={orderNumber.error}
                        errorMsg={orderNumber.errorMsg}
                        // disabled={context.editMode}
                      />
                      <FieldText
                        disabled={inputDisabled}
                        label="CW1 Order Number"
                        value={cwOrderNumber.value}
                        onChange={cwOrderNumber.onChange}
                        error={cwOrderNumber.error}
                        errorMsg={cwOrderNumber.errorMsg}
                      />
                      <FieldDate
                        disableDate={inputDisabled}
                        className="mb-0"
                        label={
                          <div className="_mandatoryfieldName">
                            Order Date
                            <span className="_madatoryFieldSymbol">*</span>
                          </div>
                        }
                        value={orderDate.value}
                        onChange={orderDate.onDateChange}
                        error={orderDate.error}
                        errorMsg={orderDate.errorMsg}
                      />
                      <div className={`width100`} style={{ marginTop: "1rem" }}>
                        <Autocomplete
                          disablePortal
                          disabled={inputDisabled}
                          disableClearable={false}
                          size="small"
                          value={sendingAgent}
                          onChange={(event, newValue) => {
                            if (!newValue) {
                              setSendingAgent({ OrgCode: "", OrgPk: "" });
                            } else {
                              setSendingAgent(newValue);
                            }
                          }}
                          options={sendingOptions ?? []}
                          getOptionLabel={(option) => option.OrgCode}
                          sx={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField {...params} label="Sending Agent" />
                          )}
                        />
                      </div>
                      <div className={`width100`}>
                        <Autocomplete
                          disabled={inputDisabled}
                          disablePortal
                          disableClearable={false}
                          size="small"
                          value={recivingAgent}
                          onChange={(event, newValue) => {
                            if (!newValue) {
                              setRecivingAgent({
                                OrgCode: "",
                                OrgPk: "",
                              });
                            } else {
                              setRecivingAgent(newValue);
                            }
                          }}
                          options={recivingOptions ?? []}
                          getOptionLabel={(option) => option.OrgCode}
                          sx={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField {...params} label="Receiving Agent" />
                          )}
                        />
                      </div>
                    </div>
                    <h5 className="my-3">Milestones</h5>
                    <div className="_orderTimelineDivParent">
                      {milestone.map((ele, index) => {
                        return (
                          <div className="_orderTimelineDiv">
                            <div className="_orderTimelineDotLine">
                              <div className="_orderTimelineDot "></div>
                              <div className="_orderTimelineLine" />
                            </div>
                            <div className="_orderTimelineInputs">
                              <h6>{ele.MilstoneDescription}</h6>
                              <FieldDate
                                label="Est. Date"
                                disableDate={inputDisabled}
                                value={ele.MilstoneEstimatedDate}
                                onChange={(text) => {
                                  onLineValueChange(
                                    "MilstoneEstimatedDate",
                                    text,
                                    index
                                  );
                                }}
                              />
                              <FieldDate
                                label="Actual Date"
                                disableDate={inputDisabled}
                                value={ele.MilstoneActualDate}
                                onChange={(text) => {
                                  onLineValueChange(
                                    "MilstoneActualDate",
                                    text,
                                    index
                                  );
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="col-md-6 col-12 _newOrderCol2">
                    <div className="_orderTimelineDivParent">
                      <div className="_orderTimelineDiv">
                        <div className="_orderTimelineDotLine">
                          <div className="_orderTimelineDot solid"></div>
                          <div className="_orderTimelineLine" />
                        </div>
                        <div className="_orderTimelineInputs">
                          <h6>Supplier:</h6>
                          {oldContext.omsUserData?.DefaultRole.includes(
                            "Supplier"
                          ) ? (
                            <FieldText
                              // disabled={inputDisabled}
                              label="Supplier Name"
                              item="OrgName"
                              value={supplierName.OrgCode}
                              disabled={true}
                            />
                          ) : (
                            <div className={`width100`}>
                              <Autocomplete
                                disablePortal
                                disabled={inputDisabled}
                                disableClearable={false}
                                size="small"
                                value={supplierName}
                                onChange={(event, newValue) => {
                                  setSupplierName(newValue ?? { OrgCode: "" });
                                }}
                                options={
                                  oldContext.omsUserData?.DefaultRole.includes(
                                    "Admin"
                                  )
                                    ? supplierNameAdmin ?? []
                                    : context.supplierName ?? []
                                }
                                getOptionLabel={(option) => option.OrgCode}
                                sx={{ width: 300 }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Supplier Name"
                                  />
                                )}
                              />
                            </div>
                          )}
                          <div className={`width100`}>
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              value={supplierAddress}
                              onChange={(event, newValue) => {
                                setSupplierAddress(
                                  newValue ?? { Address1: "" }
                                );
                              }}
                              options={senderAddOptions}
                              getOptionLabel={(option) => option.Address1}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Supplier Address"
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="_orderTimelineDiv">
                        <div className="_orderTimelineDotLine">
                          <div className="_orderTimelineDot solid"></div>
                        </div>
                        <div className="_orderTimelineInputs">
                          <h6>Buyer:</h6>
                          {oldContext.omsUserData?.DefaultRole.includes(
                            "Buyer"
                          ) ? (
                            <FieldText
                              // disabled={inputDisabled}
                              label="Buyer Name"
                              item="OrgName"
                              value={context.userData.OrgCodes ?? ""}
                              disabled={true}
                            />
                          ) : (
                            <div className={`width100`}>
                              <Autocomplete
                                disabled={inputDisabled}
                                disablePortal
                                disableClearable={false}
                                size="small"
                                value={reciverName}
                                onChange={(event, newValue) => {
                                  setReciverName(newValue ?? { OrgCode: "" });
                                }}
                                options={
                                  oldContext.omsUserData?.DefaultRole.includes(
                                    "Admin"
                                  )
                                    ? reciverNameAdmin ?? []
                                    : context.supplierName ?? []
                                }
                                getOptionLabel={(option) => option.OrgCode}
                                sx={{ width: 300 }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={
                                      oldContext.omsUserData?.DefaultRole.includes(
                                        "Supplier"
                                      ) ? (
                                        <div className="_mandatoryfieldName">
                                          Buyer Name
                                          <span className="_madatoryFieldSymbol">
                                            *
                                          </span>
                                        </div>
                                      ) : (
                                        "Buyer Name"
                                      )
                                    }
                                    error={recieverNameRequire.error}
                                    helperText={recieverNameRequire.errorMsg}
                                  />
                                )}
                              />
                            </div>
                          )}
                          <div className={`width100`}>
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              value={recieverAddress}
                              onChange={(event, newValue) => {
                                setRecieverAddress(
                                  newValue ?? { Address1: "" }
                                );
                              }}
                              options={reciverAddOptions}
                              getOptionLabel={(option) => option.Address1}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField {...params} label="Buyer Address" />
                              )}
                            />
                          </div>
                          <div className={`width100`}>
                            <Autocomplete
                              disabled={inputDisabled}
                              disableClearable={false}
                              size="small"
                              value={deleveryAddress ?? ""}
                              onChange={(event, newValue) => {
                                setDeleveryAddress(
                                  newValue ?? { Address1: "" }
                                );
                              }}
                              options={deleveryOptions}
                              getOptionLabel={(option) => option.Address1}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Final Delivery Location"
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-12 _newOrderCol3">
                <h5>ORDER DETAILS</h5>
                <div className="row _newOrderCol3Content">
                  <div className="col-sm-6 col-12">
                    <div className="width100">
                      <Autocomplete
                        disabled={inputDisabled}
                        disablePortal
                        disableClearable={false}
                        size="small"
                        value={currency}
                        onChange={(event, newValue) => {
                          currencycode.setError(false);
                          currencycode.setErrorMsg("");
                          setCurrency(newValue ?? { Code: "" });
                        }}
                        options={context.defaultValue.currency}
                        getOptionLabel={(option) => option.Code}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              <div className="_mandatoryfieldName">
                                Currency of payment
                                <span className="_madatoryFieldSymbol">*</span>
                              </div>
                            }
                            error={currencycode.error}
                            helperText={currencycode.errorMsg}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="width100">
                      <Autocomplete
                        disabled={inputDisabled}
                        disablePortal
                        disableClearable={false}
                        size="small"
                        value={incoTerm}
                        onChange={(event, newValue) => {
                          inco.setError(false);
                          inco.setErrorMsg("");
                          setIncoTerm(newValue ?? { Code: "" });
                        }}
                        options={context.defaultValue.incoTerm}
                        getOptionLabel={(option) => option.Code}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              <div className="_mandatoryfieldName">
                                Inco Term
                                <span className="_madatoryFieldSymbol">*</span>
                              </div>
                            }
                            error={inco.error}
                            helperText={inco.errorMsg}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="width100">
                      <Autocomplete
                        disabled={inputDisabled}
                        disablePortal
                        disableClearable={false}
                        size="small"
                        value={containerMode}
                        onChange={(event, newValue) => {
                          container.setError(false);
                          container.setErrorMsg("");
                          setContainerMode(newValue ?? { Mode: "" });
                        }}
                        options={context.defaultValue.containerMode}
                        getOptionLabel={(option) => option.Mode}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              <div className="_mandatoryfieldName">
                                Container Mode
                                <span className="_madatoryFieldSymbol">*</span>
                              </div>
                            }
                            error={container.error}
                            helperText={container.errorMsg}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="width100">
                      <Autocomplete
                        disabled={inputDisabled}
                        disableClearable={false}
                        disablePortal
                        size="small"
                        value={transportMode}
                        onChange={(event, newValue) => {
                          setTransportMode(newValue ?? { Description: "" });
                        }}
                        options={context.defaultValue.transportMode}
                        getOptionLabel={(option) => option.Description}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Transport Mode" />
                        )}
                      />
                    </div>
                  </div>
                  {transportMode?.Mode?.includes("SEA") ? (
                    <>
                      <div className="col-sm-6 col-12">
                        <div className="width100">
                          <TextField
                            disabled={inputDisabled}
                            label={
                              <div className="_orderWtVolInputUnits">
                                <div>Weight</div>
                                <div>(kg)</div>
                              </div>
                            }
                            type="number"
                            pattern="[0-9.]*"
                            size="small"
                            value={weight.value}
                            onChange={weight.onChange}
                            error={weight.error}
                            errorMsg={weight.errorMsg}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <TextField
                          disabled={inputDisabled}
                          label={
                            <div className="_orderWtVolInputUnits">
                              <div>Volume</div>
                              <div>(cbm)</div>
                            </div>
                          }
                          type="number"
                          pattern="[0-9.]*"
                          size="small"
                          value={volume.value}
                          onChange={volume.onChange}
                          error={volume.error}
                          errorMsg={volume.errorMsg}
                        />
                      </div>
                    </>
                  ) : null}
                  {transportMode?.Mode?.includes("AIR") ? (
                    <div className="col-sm-6 col-12">
                      <TextField
                        disabled={inputDisabled}
                        label={
                          <div className="_orderWtVolInputUnits">
                            <div>Chargeable Weight</div>
                            <div>(kg)</div>
                          </div>
                        }
                        type="number"
                        pattern="[0-9.]*"
                        size="small"
                        value={chargeableWeight.value}
                        onChange={chargeableWeight.onChange}
                        error={chargeableWeight.error}
                        errorMsg={chargeableWeight.errorMsg}
                      />
                    </div>
                  ) : null}
                  <div className="col-sm-6 col-12">
                    <FieldDate
                      disableDate={inputDisabled}
                      label="Req. Ex. Works"
                      value={reqWorkDate.value}
                      onChange={reqWorkDate.onDateChange}
                      error={reqWorkDate.error}
                      errorMsg={reqWorkDate.errorMsg}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <FieldDate
                      disableDate={inputDisabled}
                      label="Req. In Store"
                      value={reqStoreDate.value}
                      onChange={reqStoreDate.onDateChange}
                      error={reqStoreDate.error}
                      errorMsg={reqStoreDate.errorMsg}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="width100">
                      <Autocomplete
                        disabled={inputDisabled}
                        disablePortal
                        disableClearable={false}
                        size="small"
                        value={serviceLevel}
                        onChange={(event, newValue) => {
                          setServiceLevel(newValue ?? { Description: "" });
                        }}
                        options={context.defaultValue.serviceLevel}
                        getOptionLabel={(option) => option.Description}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Service Level" />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <FieldText
                      disabled={inputDisabled}
                      label="Shipment No."
                      value={adviceNumber.value}
                      onChange={adviceNumber.onChange}
                      error={adviceNumber.error}
                      errorMsg={adviceNumber.errorMsg}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <FieldText
                      disabled={inputDisabled}
                      label="Invoice No."
                      value={invoiceNumber.value}
                      onChange={invoiceNumber.onChange}
                      error={invoiceNumber.error}
                      errorMsg={invoiceNumber.errorMsg}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="width100">
                      <Autocomplete
                        disabled={inputDisabled}
                        disableClearable={false}
                        disablePortal
                        size="small"
                        value={originCountry}
                        onChange={(event, newValue) => {
                          setOriginCountry(newValue ?? { Description: "" });
                        }}
                        options={context.defaultValue.originCountry}
                        getOptionLabel={(option) => option.Description}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Origin Country" />
                        )}
                      />
                    </div>
                  </div>

                  <div className="col-12 _orderSpecificsContainerSection">
                    <div className="row">
                      <div className="col-12">
                        <h6>Containers Required</h6>
                      </div>
                    </div>
                    {containerCountInfo.map((item, index) => {
                      return (
                        <div className="row" key={index}>
                          <div className="col-md-4 col-sm-6 col-12">
                            <FieldText
                              disabled={inputDisabled}
                              label="Count"
                              value={item.OrderContainerCount}
                              onChange={(e) => {
                                if (parseInt(e.target.value) > 50) {
                                  NotificationManager.error(
                                    "Container count is not more then 50 !!!!",
                                    "",
                                    3000
                                  );
                                } else {
                                  onContainerHandler(
                                    "OrderContainerCount",
                                    e.target.value,
                                    index
                                  );
                                }
                              }}
                            />
                          </div>
                          <div className="col-md-4 col-sm-6 col-12">
                            <div className="width100">
                              <Autocomplete
                                disabled={inputDisabled}
                                disablePortal
                                disableClearable={false}
                                size="small"
                                value={item.OrderContainerType}
                                onChange={(event, newValue) => {
                                  onContainerHandler(
                                    "OrderContainerType",
                                    newValue ?? { Code: "" },
                                    index
                                  );
                                }}
                                options={context.defaultValue.containerType}
                                getOptionLabel={(option) => option.Code}
                                renderInput={(params) => (
                                  <TextField {...params} label="Type" />
                                )}
                              />
                            </div>
                          </div>
                          <div className="col-md-4 sol-sm-6 col-12">
                            <div className="_outlineButton">
                              <button
                                disabled={inputDisabled}
                                onClick={() =>
                                  onRemoveContainerCountInfo(index, item)
                                }
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="row">
                      <div className="col-12">
                        <div className="_solidButton">
                          <button
                            disabled={inputDisabled}
                            onClick={onAddContainerCountInfo}
                          >
                            ADD CONTAINERS
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <FieldText
                      disabled={inputDisabled}
                      multiline={true}
                      label="Goods Description"
                      value={goodsDescription.value}
                      onChange={goodsDescription.onChange}
                      error={goodsDescription.error}
                      errorMsg={goodsDescription.errorMsg}
                    />
                  </div>
                  <div className="col-12">
                    <FieldText
                      disabled={inputDisabled}
                      className=""
                      multiline={true}
                      label="Special Instructions"
                      value={additionalTerms.value}
                      onChange={additionalTerms.onChange}
                      error={additionalTerms.error}
                      errorMsg={additionalTerms.errorMsg}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutCreateOrder>
    </MainLayout>
  );
}

export default EditOrderSpecific;
